import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { Button } from '@repo/ui/src/components/ui/button';
import { Spinner } from '@repo/ui/src/components/ui/spinner';

export type AiDraftState = 'ready' | 'noNotes' | 'quota';

/**
 * The reason a locked button is locked is an INLINE `<p>` at every breakpoint,
 * never a tooltip: touch has no hover, so a tooltip-only reason is invisible
 * to exactly the teacher standing in the classroom (handoff §7.2). A desktop
 * Tooltip may be ADDED on top; it may not replace this line.
 */
export function AiDraftButton({
  state,
  busy,
  noteCount,
  onClick,
}: {
  state: AiDraftState;
  busy: boolean;
  noteCount: number;
  onClick: () => void;
}) {
  const { t } = useTranslation('progress');
  const disabled = busy || state !== 'ready';

  return (
    <div>
      <Button
        variant="outline"
        size="sm"
        onClick={onClick}
        disabled={disabled}
        className={state !== 'ready' ? 'opacity-50' : undefined}
      >
        {busy ? <Spinner className="h-3.5 w-3.5" /> : <Sparkles className="h-3.5 w-3.5" />}
        {busy ? t('review.ai.busy') : t('review.ai.button')}
      </Button>
      <p className="mt-1 max-w-[38ch] text-[12px] leading-snug text-surface-500">
        {state === 'noNotes'
          ? t('review.ai.helperDisabled')
          : state === 'quota'
            ? t('review.ai.quota')
            : t('review.ai.helperEnabled', { count: noteCount })}
      </p>
    </div>
  );
}
